import React from 'react';

function Footer({ siteData }) {
  const logo = siteData?.siteSettings?.logo;
  return (
    <footer className="footer">
      <div className="containerrr" style={{maxWidth: '1400px'}}>
        <div className="row">
          <div className="col-12">
            <div className="footer-content text-center">
              <div className="footer-text">
                <div className='row'>
                  <div className='col-md-3 text-start footer-main-logo'>
                    <a href="https://alj.com/tr/" target="_blank" rel="noopener noreferrer">
                  <img 
                src={logo}
                alt="Toyota Logo" 
                style={{ 
                  height: '53px', 
                  width: 'auto',
                  maxWidth: '150px'
                }} 
              /></a>
                  </div>
                  <div className='col-md-6 footer-text-aaa'>
                  {siteData.siteSettings.text_footer_main}
                  </div>
                  <div className='col-md-3 '>
                    <div className='footer-logos text-end'>
                      <div className='footer-logo-item'>
                      <a href="https://www.toyota.com.tr/" target="_blank" rel="noopener noreferrer">
                      <img src="/images/toyota_logo.svg" className='f_logo_toyota' style={{height: '25px'}} alt="Toyota logo" loading="lazy" />
                      </a>
                      </div>
                      <div className='footer-logo-item'>
                      <a href="https://www.lexus.com.tr/" target="_blank" rel="noopener noreferrer">
                      <img src="/images/lexus_logo.svg" className='f_logo_lexus' style={{height: '23px'}} alt="Lexus logo" loading="lazy" />
                      </a>
                      </div>
                      <div className='footer-logo-item last-item'>
                      <a href="https://www.bydauto.com.tr/" target="_blank" rel="noopener noreferrer">
                      <img src="/images/byd_logo.svg" className='f_logo_byd' style={{height: '16px'}}  alt="BYD logo" loading="lazy" />
                      </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div className="footer-bottom text-center">
      Copyright © ALJ {new Date().getFullYear()}
      </div>
    </footer>
  );
}

export default Footer;
